/**
 * TODO - SURVEY - This year should change all current year displays on the frontend. This needs to change after the survey migration occurs.
 */

/**
 * TODO - change to the new year after the backend new survey db and code is moved to dev
 */
export const CURRENTYEAR = 2024;
